export default __webpack_public_path__ + "static/media/login_img.241c9483.png";